export default "__VITE_ASSET__86d9370c__"